import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { CLICK_TO_CALL_BASE_URL } from "../../config";

/**
 * Click-to-call, shared by every screen that has a call button.
 *
 * The dialer places the call FROM the logged-in user's own mobile, so `agent_no`
 * must be their number — it used to be one hardcoded number, which meant every
 * call rang on that one person's phone.
 */

/** Logged-in user's mobile, stored at login inside trade_user_data. */
export const agentNumber = () => {
  try {
    const u = JSON.parse(localStorage.getItem("trade_user_data") || "{}");
    return String(u?.mobile || u?.phone || u?.contact_no || "").trim();
  } catch {
    return "";
  }
};

/**
 * The dialer answers HTTP 200 even when it refuses the call — an unregistered
 * agent number comes back as { status: 1, message: "User Not Found" }. So the
 * body has to be inspected; a 2xx alone means nothing here.
 */
const isAgentNotRegistered = (data) =>
  String(data?.message || "").trim().toLowerCase() === "user not found";

const dialerNotSetup = (number) =>
  Swal.fire({
    icon: "warning",
    title: "Dialer not set up",
    html: number
      ? `Your mobile number <strong>${number}</strong> is not registered in the dialer, so the call could not be placed.<br/><br/>Please ask the admin to register it.`
      : "Your mobile number is missing from your profile, so the dialer does not know which phone to ring.<br/><br/>Please ask the admin to add it.",
    confirmButtonColor: "#667eea",
  });

/**
 * Place a call to the client. Returns true when the dialer accepted it.
 */
export const placeClickToCall = async (clientNo, clientName = "") => {
  const agent_no = agentNumber();
  if (!agent_no) {
    dialerNotSetup("");
    return false;
  }
  try {
    const res = await axios.post(
      `${CLICK_TO_CALL_BASE_URL}/inhouse-call/public/api/click-to-call-crm` +
        `?agent_no=${encodeURIComponent(agent_no)}` +
        `&client_no=${encodeURIComponent(clientNo || "")}` +
        `&client_name=${encodeURIComponent(clientName || "")}`,
    );
    if (isAgentNotRegistered(res?.data)) {
      dialerNotSetup(agent_no);
      return false;
    }
    return true;
  } catch (err) {
    const data = err?.response?.data;
    if (isAgentNotRegistered(data)) {
      dialerNotSetup(agent_no);
      return false;
    }
    // Never surface axios's "Request failed with status code NNN".
    toast.error(data?.message || "Could not place the call. Please try again.");
    return false;
  }
};
